import { render, staticRenderFns } from "./cadmarcas.vue?vue&type=template&id=fa84e9ea&"
import script from "./cadmarcas.vue?vue&type=script&lang=js&"
export * from "./cadmarcas.vue?vue&type=script&lang=js&"
import style0 from "./cadmarcas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports